import Microgame from '../engine/Microgame.js';

export default class OrderGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Dans l'ordre !`, en: `In Order!`, es: `¡En Orden!` },
            controls: { fr: `Touche les éléments dans l'ordre de 1 à X`, en: `Tap the items in sequential order from 1 to X`, es: `Toca los elementos en orden numérico del 1 al X` },
            objective: { fr: `Remets tout dans le bon ordre sans te tromper`, en: `Put everything in the right order without mistakes`, es: `Pon todo en orden sin equivocarte` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M11 12H3"/><path d="M16 6H3"/><path d="M16 18H3"/><path d="M21 12h-4"/><path d="M21 6h-1"/><path d="M21 18h-1"/></svg>`,
            actions: [
                { type: 'wait', duration: 360 },
                { type: 'tapTarget', selector: '[data-order-btn="1"]', duration: 170 },
                { type: 'wait', duration: 150 },
                { type: 'tapTarget', selector: '[data-order-btn="2"]', duration: 170 },
                { type: 'wait', duration: 150 },
                { type: 'tapTarget', selector: '[data-order-btn="3"]', duration: 170 },
                { type: 'wait', duration: 320 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.currentNumber = 1;
        this.maxNumber = 3;

        // Scale duration so max speed (4.0) feels like the old 2.6 speed
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeed = 1 + (speedMult - 1) * (1.6 / 3);
        // Base duration is approximately 3000ms if not explicitly defined (assuming engine uses a default if missing, or we can just set it here)
        this.duration = 4000 * (speedMult / adjustedSpeed);
    }

    setup() {
        this.engine.ui.instruction.textContent = "1-2-3!";

        for (let i = 1; i <= this.maxNumber; i++) {
            const btn = document.createElement('div');
            const color = Math.random() > 0.5 ? this.primaryColor : this.secondaryColor;

            btn.textContent = i;
            btn.style.position = 'absolute';
            btn.style.width = '80px';
            btn.style.height = '80px';
            btn.style.background = 'transparent';
            btn.style.border = `4px solid ${color}`;
            btn.style.borderRadius = '50%';
            btn.style.color = color;
            btn.style.fontSize = '2.5rem';
            btn.style.fontWeight = 'bold';
            btn.style.display = 'flex';
            btn.style.justifyContent = 'center';
            btn.style.alignItems = 'center';
            btn.style.boxShadow = `0 0 15px ${color}`;
            btn.style.cursor = 'pointer';

            // Random Position without overlap
            const btnSize = 88; // 80px + 4px border each side
            const padding = 10;
            let x, y, overlapping;
            let attempts = 0;
            const placed = Array.from(this.container.querySelectorAll('[data-order-btn]'));

            do {
                overlapping = false;
                x = Math.random() * (this.container.clientWidth - btnSize - padding * 2) + padding;
                y = Math.random() * (this.container.clientHeight - btnSize - padding * 2) + padding;

                for (const other of placed) {
                    const ox = parseFloat(other.style.left);
                    const oy = parseFloat(other.style.top);
                    if (Math.abs(x - ox) < btnSize + 5 && Math.abs(y - oy) < btnSize + 5) {
                        overlapping = true;
                        break;
                    }
                }
                attempts++;
            } while (overlapping && attempts < 50);

            btn.setAttribute('data-order-btn', i);
            btn.style.left = `${x}px`;
            btn.style.top = `${y}px`;

            btn.addEventListener('pointerdown', () => {
                if (!this.active) return;

                if (i === this.currentNumber) {
                    // Correct
                    btn.style.background = color;
                    btn.style.color = '#000';
                    btn.style.transform = 'scale(0.9)';
                    this.currentNumber++;

                    if (this.currentNumber > this.maxNumber) {
                        this.win();
                    }
                } else {
                    // Wrong
                    this.lose();
                }
            });

            this.container.appendChild(btn);
        }
    }
}
